import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';
import { Meta , Title} from '@angular/platform-browser';

@Component({
    selector: 'app-ccpa',
    templateUrl: './ccpa.component.html',
    styleUrls: ['./../landing/landing.component.css', './ccpa.component.css'],
    standalone: false
})
export class CcpaComponent implements OnInit {
  @ViewChild('pricing') pricing;
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal,
    private meta: Meta,
    private title: Title
  ) {
    this.title.setTitle('Ccpa | Family Central');
    this.meta.addTag({
      name: 'description',
      content: "How we ensure our customers' privacy with CCPA compliance.",
    });
  }

  ngOnInit(): void {
    this.loader.HideLoading();
  }

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  onClose() {
    this.modalService.dismissAll();
  }
}
